import { cn } from "@/lib/utils";

/**
 * A return as a signed number, with a real minus sign (U+2212) so negative
 * columns line up with positive ones in a tabular font.
 */
export function formatReturn(value: number, decimals: number): string {
  const text = Math.abs(value).toFixed(decimals);
  return Number(text) === 0 ? text : value < 0 ? `−${text}` : text;
}

type ReturnValueProps = {
  /** The return in percent. */
  value: number;
  decimals?: number;
  /** Shown after the number, e.g. "%". */
  suffix?: string;
  /** A period measured to date or cut by the history's start: grey, marked with *. */
  partial?: boolean;
  className?: string;
};

/**
 * A return coloured by its sign (QL-706): green above zero, red below, plain at
 * zero (as rounded). A partial period is grey whatever its sign, and starred.
 */
export function ReturnValue({
  value,
  decimals = 1,
  suffix = "",
  partial = false,
  className,
}: ReturnValueProps) {
  const text = formatReturn(value, decimals);
  const rounded = Number(text.replace("−", "-"));
  const tone = partial
    ? "text-muted-foreground"
    : rounded > 0
      ? "text-success"
      : rounded < 0
        ? "text-destructive"
        : undefined;
  return (
    <span className={cn("tabular-nums", tone, className)}>
      {text}
      {suffix}
      {partial ? "*" : ""}
    </span>
  );
}
